<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <b-navbar-brand to="/" tag="router-link">Luanva</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <!-- Si el usuario está autenticado -->
          <template v-if="isAuthenticated">
            <b-nav-item to="/articulos" tag="router-link">Articulos</b-nav-item>
            <b-nav-item to="/sales" tag="router-link">Ventas</b-nav-item>
            <b-nav-item to="/venta" tag="router-link">Nueva Venta</b-nav-item>
            <b-nav-item to="/statistics" tag="router-link">Estadísticas</b-nav-item>

            <b-nav-item-dropdown right>
              <template #button-content> 👤 {{ user.name }} </template>
              <b-dropdown-item @click="logoutUser"
                >Cerrar sesión</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </template>

          <!-- Si NO está autenticado -->
          <template v-else>
            <b-nav-item to="/login" tag="router-link"
              >Iniciar sesión</b-nav-item
            >
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "user"]),
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    async logoutUser() {
      try {
        await this.logout();
        this.$router.push("/login");
      } catch (e) {
        console.error("Error al cerrar sesión", e);
      }
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');

body {
  background-color: #f8fafc; /* Very light modern background */
}

#app {
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1e293b;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Premium Navbar */
.navbar {
  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 1rem 2rem;
}
.navbar-brand {
  font-weight: 700;
  font-size: 1.5rem;
  letter-spacing: -0.5px;
}
.nav-link {
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}
.nav-link:hover {
  transform: translateY(-1px);
  color: #e0e7ff !important;
}

/* Global utility classes for glassmorphism and modern cards */
.glass-card {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.025) !important;
  border-radius: 1rem !important;
}

/* Button enhancements */
.btn {
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}
.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

router-view {
  flex: 1;
}
</style>
